import script from "./RoleItemSource.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleItemSource.vue?vue&type=script&setup=true&lang=js"

import "./RoleItemSource.vue?vue&type=style&index=0&id=1f5c8097&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5c8097"]])

export default __exports__